import { Tenants, Languages } from 'entities/Config'

export const getTenant = (): Tenants =>
  ((global as any)._saeConversational?.tenant || Tenants.COM) as Tenants

export const getLanguage = (): Languages =>
  ((global as any)._saeConversational?.language || Languages.DE) as Languages

const gtmContainerId = {
  [Tenants.COM]: 'GTM-PVRM45G',
  [Tenants.ERX]: 'GTM-PVRM45G',
  [Tenants.IT]: 'GTM-TWNBFW7',
  [Tenants.BE]: 'GTM-T7HHPSRG',
}

export const getGtmContainerId = () => {
  const tenant = getTenant()

  return gtmContainerId[tenant]
}
